import React, { useState } from "react";

const Sdarsan = ({ onBookClick }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <section className="suvarna-darsan-section">
      {/* Decorative floating particles */}
      <span className="particle particle-1">✦</span>
      <span className="particle particle-2">✧</span>
      <span className="particle particle-3">✦</span>
      <span className="particle particle-4">✧</span>

      <div className="darsan-card">
        {/* Decorative glow */}
        <div className="gold-glow" />
        <div className="mandala mandala-left">✺</div>
        <div className="mandala mandala-right">✺</div>

        <div className="darsan-content">
          {/* Left Content */}
          <div className="darsan-text">
            {/* <div className="eyebrow">
              <span className="line" />
              <span>Suvarna Darsan</span>
              <span className="line" />
            </div> */}

            <h2 style={{fontSize:'25pt'}}>
              <span>SUVARNA DARSAN</span>
            </h2>

            {/* <p className="description">
              Experience the divine presence of Lord Padmanabhaswamy
              with an unforgettable Suvarna Darsan.
            </p> */}

            <div className="benefits">
              {/* <div className="benefit">
                <span className="benefit-icon">🪔</span>
                <span>Divine Darsan</span>
              </div> */}

              {/* <div className="benefit">
                <span className="benefit-icon">✦</span>
                <span>Online Booking</span>
              </div> */}

              {/* <div className="benefit">
                <span className="benefit-icon">🙏</span>
                <span>Special Experience</span>
              </div> */}
            </div>
          </div>

          {/* Right Booking Box */}
          <div className="booking-area">
            <a
                href="https://booking.sreepadmanabhaswamytemple.org/OtherOfferings.aspx?Pid=1&Vid=75"
                onClick={onBookClick}
                className={`book-button ${isHovered ? "active" : ""}`}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <span>BOOK NOW</span>
                <span className="arrow">→</span>
              </a>
            {/* <div className="booking-circle">
              <div className="circle-inner">
                <span className="diya">🪔</span>
                <span className="circle-text">DIVINE</span>
                <span className="circle-text">DARSHAN</span>
              </div>
            </div> */}

            {/* <div className="booking-info">
              <p>ONLINE DARSAN SLOT BOOKING</p>

              <a
                href="https://www.sreepadmanabhaswamytemple.org/booking"
                onClick={onBookClick}
                className={`book-button ${isHovered ? "active" : ""}`}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <span>BOOK NOW</span>
                <span className="arrow">→</span>
              </a>

              <small>
                Suvarna Darsan
              </small>
            </div> */}
          </div>
        </div>

        {/* Bottom decorative line */}
        <div className="bottom-decoration">
          <span>❈</span>
          <div />
          {/* <span>ॐ</span> */}
          <div />
          <span>❈</span>
        </div>
      </div>

      <style>{`
        .suvarna-darsan-section {
          width: 100%;
          // padding: 35px 15px;
          // position: relative;
          // overflow: hidden;
          font-family: Georgia, "Times New Roman", serif;
        }

        .darsan-card {
          // position: relative;
          max-width: 1150px;
          // margin: 0 auto;
          overflow: hidden;
          border-radius: 28px;
        padding: 10px;
         height:120px;
          background:
            radial-gradient(
              circle at 15% 20%,
              rgba(93, 3, 3, 0.78),
              transparent 30%
            ),
            radial-gradient(
              circle at 85% 80%,
              rgb(113, 3, 1),
              transparent 30%
            ),
            linear-gradient(
              135deg,
              #5d0404 0%,
              #5c2e00 35%,
              #ff3502 65%,
              #f30505 100%
            );

          border: 1px solid rgba(255, 224, 130, 0.55);

          box-shadow:
            0 25px 60px rgba(53, 34, 0, 0.4),
            inset 0 1px 0 rgba(255,255,255,0.18),
            inset 0 0 50px rgba(255, 211, 70, 0.08);

          transition:
            transform 0.4s ease,
            box-shadow 0.4s ease;
        }

        .darsan-card:hover {
          transform: translateY(-5px);

          box-shadow:
            0 35px 80px rgba(53, 34, 0, 0.5),
            0 0 35px rgba(255, 210, 70, 0.18),
            inset 0 1px 0 rgba(255,255,255,0.2);
        }

        .gold-glow {
          position: absolute;
          width: 300px;
          height: 300px;
          top: -180px;
          left: 50%;
          transform: translateX(-50%);
          border-radius: 50%;

          background: rgba(255, 215, 70, 0.3);
          filter: blur(70px);
          pointer-events: none;
        }

        .darsan-content {
          position: relative;
          z-index: 2;

          display: grid;
          grid-template-columns: 1.4fr 0.9fr;
          align-items: center;
          
          
        }

        .darsan-text {
          text-align: center;
        }

        .eyebrow {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;

          color: #f8d976;
          font-size: 11px;
          font-weight: bold;
          letter-spacing: 4px;
          margin-bottom: 18px;
        }

        .line {
          width: 45px;
          height: 1px;
          background: linear-gradient(
            to right,
            transparent,
            #6e0000
          );
        }

        .line:last-child {
          background: linear-gradient(
            to left,
            transparent,
            #6f0000
          );
        }

        .darsan-text h2 {
          margin: 0;

          font-size: clamp(2rem, 5vw, 4rem);
          line-height: 1.05;
          font-weight: 700;
          letter-spacing: 2px;

          color: #fff4c5;

          text-shadow:
            0 3px 8px rgba(0,0,0,0.6),
            0 0 20px rgba(255,215,100,0.15);
        }

        .darsan-text h2 span {
          color: #ffd65a;

          background: linear-gradient(
            90deg,
            #ffd2a8,
            #d9a927,
            #6b0000
          );

          background-size: 200% auto;
          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent;

          animation: goldShimmer 4s linear infinite;
        }

        @keyframes goldShimmer {
          to {
            background-position: 200% center;
          }
        }

        .description {
          max-width: 600px;
          margin: 20px auto 0;

          color: rgba(255, 246, 210, 0.85);
          font-family: Arial, sans-serif;
          font-size: 15px;
          line-height: 1.7;
        }

        .benefits {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          gap: 12px;
          margin-top: 25px;
        }

        .benefit {
          display: flex;
          align-items: center;
          gap: 7px;

          padding: 9px 14px;

          border-radius: 50px;

          background: rgba(255,255,255,0.08);
          border: 1px solid rgba(255,220,120,0.2);

          color: #ffe9a3;
          font-family: Arial, sans-serif;
          font-size: 12px;

          backdrop-filter: blur(8px);

          transition: all 0.3s ease;
        }

        .benefit:hover {
          transform: translateY(-3px);
          background: rgba(255,215,80,0.16);
          border-color: rgba(255,220,120,0.5);
        }

        .benefit-icon {
          font-size: 15px;
        }

        .booking-area {
          // min-height: 280px;

          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          padding: 25px;

          border-radius: 24px;

          // background:
          //   linear-gradient(
          //     145deg,
          //     rgba(255,255,255,0.12),
          //     rgba(255,255,255,0.035)
          //   );

          // border: 1px solid rgba(255,220,130,0.25);

          // backdrop-filter: blur(12px);

          // box-shadow:
          //   inset 0 1px 0 rgba(255,255,255,0.12);
        }

        .booking-circle {
          width: 120px;
          height: 120px;

          border-radius: 50%;

          padding: 5px;

          background: linear-gradient(
            135deg,
            #fff0a0,
            #c99720,
            #ffe27a
          );

          box-shadow:
            0 0 25px rgba(255,210,70,0.25),
            0 8px 20px rgba(0,0,0,0.3);

          animation: gentleFloat 4s ease-in-out infinite;
        }

        @keyframes gentleFloat {
          0%, 100% {
            transform: translateY(0);
          }

          50% {
            transform: translateY(-8px);
          }
        }

        .circle-inner {
          width: 100%;
          height: 100%;

          border-radius: 50%;

          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          background:
            radial-gradient(
              circle,
              #8e680c,
              #4a3303
            );

          border: 1px solid rgba(255,240,170,0.35);

          color: #ffe89a;
        }

        .diya {
          font-size: 30px;
          margin-bottom: 3px;

          filter:
            drop-shadow(0 0 8px rgba(255,190,40,0.8));
        }

        .circle-text {
          font-family: Arial, sans-serif;
          font-size: 9px;
          letter-spacing: 2px;
          font-weight: bold;
        }

        .booking-info {
          text-align: center;
          margin-top: 20px;
        }

        .booking-info p {
          margin: 0 0 14px;

          color: #ffe6a0;

          font-family: Arial, sans-serif;
          font-size: 11px;
          font-weight: bold;
          letter-spacing: 2px;
        }

        .book-button {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 18px;

          min-width: 190px;

          padding: 14px 22px;

          border-radius: 50px;

          text-decoration: none;

          color: #4b3100;
          background: linear-gradient(
            135deg,
            #fff0a0,
            #d4a62b,
            #ffe477
          );

          font-family: Arial, sans-serif;
          font-size: 14px;
          font-weight: 800;
          letter-spacing: 1.5px;

          box-shadow:
            0 8px 20px rgba(0,0,0,0.3),
            0 0 0 rgba(255,215,80,0);

          transition: all 0.3s ease;
        }

        .book-button:hover,
        .book-button.active {
          transform: translateY(-4px) scale(1.03);

          box-shadow:
            0 12px 25px rgba(0,0,0,0.35),
            0 0 25px rgba(255,220,90,0.4);

          color: #3c2600;
        }

        .arrow {
          font-size: 20px;
          transition: transform 0.3s ease;
        }

        .book-button:hover .arrow {
          transform: translateX(6px);
        }

        .booking-info small {
          display: block;

          margin-top: 12px;

          color: rgba(255,241,190,0.6);

          font-family: Arial, sans-serif;
          font-size: 10px;
        }

        .bottom-decoration {
          position: relative;
          z-index: 2;

          display: flex;
          align-items: center;
          justify-content: center;

          gap: 12px;

          margin-top: 30px;

          color: #dcb747;
          opacity: 0.7;
        }

        .bottom-decoration div {
          width: 100px;
          height: 1px;

          background: linear-gradient(
            to right,
            transparent,
            #dc5647,
            transparent
          );
        }

        .bottom-decoration span {
          font-size: 14px;
        }

        .mandala {
          position: absolute;

          color: rgba(255,215,90,0.09);

          font-size: 180px;

          pointer-events: none;
        }

        .mandala-left {
          left: -65px;
          top: 50%;
          transform: translateY(-50%);
        }

        .mandala-right {
          right: -65px;
          top: 50%;
          transform: translateY(-50%);
        }

        .particle {
          position: absolute;

          color: #e9c653;

          opacity: 0.5;

          animation: particleFloat 5s ease-in-out infinite;

          pointer-events: none;
        }

        .particle-1 {
          left: 8%;
          top: 20%;
          font-size: 18px;
        }

        .particle-2 {
          right: 8%;
          top: 30%;
          font-size: 14px;
          animation-delay: 1s;
        }

        .particle-3 {
          left: 15%;
          bottom: 20%;
          font-size: 12px;
          animation-delay: 2s;
        }

        .particle-4 {
          right: 15%;
          bottom: 15%;
          font-size: 20px;
          animation-delay: 3s;
        }

        @keyframes particleFloat {
          0%, 100% {
            transform: translateY(0) rotate(0deg);
          }

          50% {
            transform: translateY(-15px) rotate(90deg);
          }
        }

        /* Tablet */
        @media (max-width: 850px) {
          .darsan-card {
            padding: 35px 25px 22px;
            height:250px;
          }

          .darsan-content {
            grid-template-columns: 1fr;
            gap: 30px;
          }

          .booking-area {
            min-height: auto;
          }

          .description {
            max-width: 650px;
          }
        }

        /* Mobile */
        @media (max-width: 576px) {
          .suvarna-darsan-section {
            padding: 20px 10px;
          }

          .darsan-card {
            padding: 32px 18px 20px;
            border-radius: 22px;
            height:320px;
          }

          .eyebrow {
            font-size: 8px;
            letter-spacing: 2px;
            gap: 7px;
          }

          .line {
            width: 25px;
          }

          .darsan-text h2 {
            font-size: 2rem;
          }

          .description {
            font-size: 13px;
          }

          .benefits {
            gap: 7px;
          }

          .benefit {
            padding: 7px 10px;
            font-size: 10px;
          }

          .booking-area {
            padding: 20px 12px;
          }

          .booking-circle {
            width: 100px;
            height: 100px;
          }

          .book-button {
            width: 100%;
            min-width: 0;
          }

          .mandala {
            font-size: 100px;
          }

          .bottom-decoration div {
            width: 45px;
          }
        }
      `}</style>
    </section>
  );
};

export default Sdarsan;
